module.exports = __webpack_public_path__ + "img/logo.d7ac578.png";